import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_SEGMENTS_APP_ROOT = `${BASE_ADMIN_V2_PATH}/segments`;

export const ADMIN_SEGMENTS_APP_PATHS = {
  SEGMENTS_LIST: `${ADMIN_SEGMENTS_APP_ROOT}`,
  SEGMENT_DETAILS: (segmentId: string) => `${ADMIN_SEGMENTS_APP_ROOT}/${segmentId}/details`,
};
